import { ButtonGroup as Btn } from '@mui/material';
import React from 'react';

const CustomButtonGroup = (props) => {
  return React.createElement(Btn, {
    ...props,
  });
};

export default CustomButtonGroup;
